module.exports = __webpack_public_path__ + "img/its_logo_horizontal.53a511a9.png";